import React, { Component } from "react";
import _ from "lodash";
import { Radio } from "antd";
import Ajax from "Pub/js/ajax";
//自定义组件
import { connect } from "react-redux";
import {
    toggleEditStatus,
    updateGroupList,
    setAppGroupData,
    setSaveComplete,
    setUpdateLayout,
    setExternalLinks,
} from "Store/GridLayout/action";
import { setLinkageData, setWorkbenchData } from "Store/appStore/action";
import {
    removeTargetCardsInGroup,
    setPropertyValueForCardsInCards,
    hasCheckedCardInGroups,
    hasCheckedCardInCompactApp,
    hasExpiredCard,
    checkApp,
    findDataByCompactApp,
    calcDraggingItemsPos,
    PUB_WIDGET_APPCODES,
    getEffectiveLinkData,
} from "./utilService";
import Notice from "Components/Notice";
import HotKeysModal from "Components/HotKeysModal";
import { withRouter } from "react-router-dom";
import { ControlTip } from "Components/ControlTip"; //黎明弹出框
import { getWorkbenchData, GetQuery, langCheck, debounce, getOriginPath } from "Pub/js/utils";
import platform from "Pub/js/platform";
const RadioGroup = Radio.Group;
const { NCDiv, NCButton, NCTooltip, NCModal, NCCheckbox, NCHotKeys } = platform.base;
const { PubSub, promptBox } = platform;
const linkageColors = [
    '#E51373',
    '#F06E05',
    '#59E513',
    '#1353E5',
    '#BA13E5',
    '#13E2E5',
    '#2779A1',
    '#3A424D',
];

//footer
class MyFooter extends Component {
    constructor(props) {
        super(props);
        const urlQuery = GetQuery(props.location.search);
        const isDesign = Boolean(urlQuery.workbenchid); // 桌面设计
        this.state = {
            modalVisible: false,
            selectedValue: 0,
            linkageSetModal: false, // 联动设置弹窗
            linkageModalData: [], // 联动设置弹窗数据
            linkageActive: null, // 联动选中数据
            isDesign,
        };
        window.isDesign = isDesign;
    }
    componentDidMount() {
        //监听其他地方调用桌面保存事件
        this.pubsub = PubSub.subscribe("saveDesktopOutside", (action, data = { isOtherWay: true }) => {
            // data = {
            //     isOtherWay: true, // 是否为非编辑态保存
            //     saveCallback: () => {} // 保存成功回调
            // }
            this.saveGroupItemAndCard(data);
        });
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.pubsub); //移除订阅
    }
    //删除若干目标卡片的方法
    deleteTargetCards = (property, value) => {
        let { groups, appGroupMap } = this.props;
        groups = _.cloneDeep(groups);
        removeTargetCardsInGroup(groups, property, value);

        //删除聚合应用内应用
        for (const cardid in appGroupMap) {
            const appGroupData = appGroupMap[cardid];
            _.remove(appGroupData, app => app[property] === value);
        }
        this.props.updateGroupList(groups);
        this.props.setAppGroupData(appGroupMap);
        this.props.onCheckDeduplication(groups);
    };

    //生成移动弹框需要的数据
    genMoveRadioData = () => {
        const { groups, appGroupMap } = this.props;
        let result = _.cloneDeep(groups);
        const compactAppKeys = Object.keys(appGroupMap);
        result.forEach(group => {
            group.compactApps = [];
            group.apps && group.apps.forEach(app => {
                if (compactAppKeys.includes(app.cardid)) {
                    group.compactApps.push(app);
                }
            });
        });
        return result;
    }
    getGroupItemNameRadio = () => {
        const groups = this.genMoveRadioData();
        const renderRadio = g => {
            return (
                <Radio
                    className="modal-radio"
                    key={g.pk_app_group}
                    value={g.pk_app_group}
                >
                    {g.groupname}
                </Radio>
            );
        };
        return (
            <RadioGroup
                className="modal-radio-group"
                value={this.state.selectedValue}
                onChange={this.onChangeRadio.bind(this)}
            >
                {groups.map((g, i) => {
                    //渲染聚合应用radio
                    if (g.compactApps && g.compactApps.length) {
                        return (
                            <React.Fragment>
                                {renderRadio(g)}
                                {
                                    g.compactApps.map(capp => (
                                        <Radio
                                            className="modal-radio second"
                                            key={capp.cardid}
                                            value={capp.cardid}
                                        >
                                            {capp.name}
                                        </Radio>
                                    ))
                                }
                            </React.Fragment>
                        );
                    } else {
                        return renderRadio(g);
                    }
                })}
            </RadioGroup>
        );
    };
    //移动到的弹出框中，组名选择
    onChangeRadio = e => {
        this.setState({ selectedValue: e.target.value });
    };
    showModalVisible = () => {
        this.setModalVisible(true);
    };
    showModalHidden = () => {
        this.setModalVisible(false);
    };
    setModalVisible = modalVisible => {
        this.setState({ modalVisible, selectedValue: 0 });
    };

    //应用移动到分组 onlyMoveWidget:只移动部件 groupIndex:要移动group的index
    moveApps2Group = () => {
        let groups = _.cloneDeep(this.props.groups);
        const [chekcedCompactApps] = this.moveCompactApp("group");
        const targetGroupID = this.state.selectedValue;
        if (targetGroupID === 0) {return;}
        //获取选中card
        // let sourceGroupIDArr = [];
        let moveCardArr = [];
        let targetGroupIndex = -1;
        groups.forEach((g, i) => {
            // let flag = false;
            //获取目标分组
            if (g.pk_app_group === targetGroupID) {
                targetGroupIndex = i;
                // sourceGroupIDArr.push(g.pk_app_group);
            }
            //删除选中card
            let removedCards = _.remove(g.apps, a => {
                // if (a.isChecked) {
                //     flag = true;
                // }
                return a.isChecked;
            });

            /**
             *  追加聚合应用内选中的应用
             */
            if (chekcedCompactApps) {
                removedCards = removedCards.concat(chekcedCompactApps);
            }
            // if (flag && sourceGroupIDArr.indexOf(g.pk_app_group) === -1) {
            //     sourceGroupIDArr.push(g.pk_app_group);
            // }
            moveCardArr = moveCardArr.concat(removedCards);
        });

        //重新计算移动后的位置
        moveCardArr = calcDraggingItemsPos(_.uniqBy(moveCardArr, "cardid"), { x: 0, y: 99 });

        //在目标分组新增去重后的card
        groups[targetGroupIndex].apps = groups[targetGroupIndex].apps.concat(moveCardArr);
        groups[targetGroupIndex].apps = _.uniqBy(groups[targetGroupIndex].apps, "cardid");

        this.props.updateGroupList(groups);
        return groups;
    }
    //移动聚合应用内的应用 moveTo:移动到分组还是聚合应用 group:分组 compactApp:聚合应用
    moveCompactApp = moveTo => {
        let { appGroupMap } = this.props;
        if (Object.keys(appGroupMap).length === 0) {return [];}
        appGroupMap = _.cloneDeep(appGroupMap);
        delete appGroupMap.updateAll; //todo 优化
        let checkedApps = [];
        for (const cardid in appGroupMap) {
            const appGroupData = appGroupMap[cardid];
            const compactApp = findDataByCompactApp(this.props.groups, cardid);
            /**
                移动聚合应用到分组如果聚合应用是选中的，说明聚合内的应用全部选中，
                这时只需移动聚合应用，不需要移动聚合内应用
            */
            if (moveTo === "group") {
                if (compactApp && compactApp.app && !compactApp.app.isChecked) {
                    const removedApps = _.remove(appGroupData, a => a.isChecked);
                    checkedApps = checkedApps.concat(removedApps);
                } else {
                    //清空聚合应用内选中状态
                    Array.isArray(appGroupData) && appGroupData.forEach(item => {
                        item.isChecked = false;
                    });
                }
            } else {
                const removedApps = _.remove(appGroupData, a => a.isChecked);
                checkedApps = checkedApps.concat(removedApps);
            }
        }
        this.props.setAppGroupData(appGroupMap);
        return [checkedApps, appGroupMap];
    }

    //移动到聚合应用
    moveApps2CompactApp = () => {
        const targetCompactAppId = this.state.selectedValue;
        let { groups } = this.props;
        const { group: targetGroup, groupIndex } = findDataByCompactApp(groups, targetCompactAppId);
        const [chekcedCompactApps, appGroupMap] = this.moveCompactApp("compactApp");
        let movedCards = [], movedWidgets = [];

        //其他应用移动到聚合应用中
        //移动分组内应用
        groups.forEach(group => {
            //删除选中card
            let removedCards = _.remove(group.apps, a => {
                if (a.isChecked) {
                    //部件移动到分组上
                    if (checkApp(a).isOnlyWidget) {
                        //部件移动到同组聚合时不删除
                        if (targetGroup.pk_app_group === group.pk_app_group) {
                            return false;
                        } else {
                            movedWidgets = movedWidgets.concat(a);
                            return true;
                        }
                    } else {
                        //自己移到自己不删除自己
                        return targetCompactAppId !== a.cardid;
                    }
                }
                return false;
            });
            //追加聚合应用内选中的应用
            if (chekcedCompactApps) {
                removedCards = removedCards.concat(chekcedCompactApps);
            }
            movedCards = movedCards.concat(removedCards);
        });

        //过滤只有应用能移动到聚合应用中
        movedCards = movedCards.filter(item => checkApp(item).isAppOrLink);
        //在目标聚合应用新增去重后的card
        let targetAppGroupData = appGroupMap[targetCompactAppId].concat(movedCards);
        targetAppGroupData = _.uniqBy(targetAppGroupData, "cardid");
        appGroupMap[targetCompactAppId] = targetAppGroupData;
        this.props.setAppGroupData(appGroupMap);

        //在目标分组新增去重后的部件
        groups[groupIndex].apps = groups[groupIndex].apps.concat(movedWidgets);
        groups[groupIndex].apps = _.uniqBy(groups[groupIndex].apps, "cardid");
        this.props.updateGroupList(groups);
    }

    //取消所有card选中状态
    clearAppChecked = () => {
        let groups = _.cloneDeep(this.props.groups);
        let appGroupMap = _.cloneDeep(this.props.appGroupMap);
        //清除分组card选中状态
        groups.forEach(item => {
            setPropertyValueForCardsInCards(item.apps, "isChecked", false);
        });
        //清除聚合应用选中状态
        if (Object.keys(appGroupMap).length) {
            for (const cardid in appGroupMap) {
                if (Array.isArray(appGroupMap[cardid])) {
                    setPropertyValueForCardsInCards(appGroupMap[cardid], "isChecked", false);
                }
            }
        }
        this.props.setAppGroupData(appGroupMap);
        this.props.updateGroupList(groups);
    }

    //移动到的弹出框中，点击确认
    onOkMoveDialog = () => {
        const { selectedValue } = this.state;
        if (!selectedValue) {return;}
        const targetGroup = this.props.groups.find(item => item.pk_app_group === selectedValue);
        //移动到分组
        if (targetGroup) {
            this.moveApps2Group();
        } else {
            //移动到聚合应用
            this.moveApps2CompactApp();
        }
        this.props.setUpdateLayout(true); //设置移动标示通知GridLayout更新布局
        //取消所有card选中状态，异步目的拿到最新props
        setTimeout(() => {
            this.props.setUpdateLayout(false);
            this.clearAppChecked(); //清空选中状态
            PubSub.publish("updateAppGroupCache"); //更新聚合应用缓存
            this.showModalHidden();
        }, 0);
    };
    cancleSave = () => {
        if (this.props.relateidObj.type === "userID") {
            // this.props.history.push(`/`);
            // this.props.updateGroupList(this.props.initialGroups);
            // this.props.setAppGroupData(_.cloneDeep(this.props.defaultAppGroupData));
            this.props.updateHomePage(() => {
                this.props.toggleEditStatus(false);
            });
            // 清空常用链接redux数据
            // this.props.setExternalLinks(null);
        } else {
            self.opener = null;
            self.close();
        }
    };
    //抽象方法，参数为显示的button文本和方法体，注意方法提前bind
    getMoveCardButton = (text, fieldid, fn) => {
        let tmpDom;
        const { groups, appGroupMap } = this.props;
        const hasAppChecked = hasCheckedCardInGroups(groups);
        const hasCompactAppChecked = hasCheckedCardInCompactApp(appGroupMap);
        const isDisabled = hasAppChecked || hasCompactAppChecked;
        tmpDom = (
            <NCButton disabled={!isDisabled} onClick={fn} fieldid={fieldid} className="footer-button">
                {text}
            </NCButton>
        );
        return tmpDom;
    };
    //清除失效btn
    getExpiredCardButton = (text, fn) => {
        const { relateidObj } = this.props;
        if (relateidObj.type === 'workbench') {return null;}

        let expiredDom;
        const { groups, appGroupMap } = this.props;
        const isDisabled = hasExpiredCard(groups, appGroupMap);
        expiredDom = (
            <NCTooltip
                overlay={
                    this.props.json["DesktopSetting-000003"]
                } /* 国际化处理： 点击按钮, 清除所有无权限的应用*/
            >
                <NCButton
                    fieldid="clear"
                    disabled={!isDisabled}
                    onClick={fn}
                    className="footer-button"
                >
                    {text}
                </NCButton>
            </NCTooltip>
        );
        return expiredDom;
    };
    //生成保存需要的数据
    genSaveData = () => {
        let result = [];
        const { appGroupMap } = this.props;
        _.forEach(this.props.groups, (g, i) => {
            let tmp = {
                groupname: g.groupname,
                apps: [],
                position: i,
            };
            if (g.pk_app_group.indexOf("newGroupItem") === -1) {
                tmp.pk_app_group = g.pk_app_group;
            }
            _.forEach(g.apps, a => {
                if (a.cardid && a.cardid.indexOf("_") !== -1) {
                    const tmpIDArr = a.cardid.split("_");
                    a.cardid = tmpIDArr[0];
                }

                // 公共的
                const commonObj = {
                    appcode: a.appcode,
                    cardid: a.cardid,
                    gridx: a.gridx,
                    gridy: a.gridy,
                    width: a.width + '',
                    height: a.height + '',
                    pk_group_app: a.pk_group_app,
                    is_cloud_app: a.is_cloud_app,
                    image_src: a.image_src,
                    name: a.name,
                    appid: a.appid,
                };

                // 特殊处理的
                let otherObj = {};
                const checkObj = checkApp(a);
                if (checkObj.isCompactApp) {
                    otherObj = {
                        children: appGroupMap[a.cardid], // 聚合应用内容
                        parttype: "0", // 常用应用
                        name: a.name,
                    };
                    if (checkObj.isQuickLaunch) { // 快速发起
                        otherObj.parttype = '2';
                    }
                }
                if (checkObj.isExternalLink) {
                    otherObj.parttype = "1"; // 外部链接
                }
                if (checkObj.isIndicatorCard) {
                    otherObj.parttype = "3"; // 指标卡
                }
                if (checkObj.isCommonFilter) { // 公共筛选器
                    otherObj.parttype = "4";
                }
                if (checkObj.isBillStatistics) { // 单据统计
                    otherObj.parttype = '5';
                }

                if (a.sideData && Object.keys(a.sideData).length) { // 侧拉配置
                    otherObj.component_configuration = JSON.stringify(a.sideData);
                    if (a.sideData.permission_code) { // 权限（目前针对指标卡）
                        otherObj.permission_code = a.sideData.permission_code;
                    }
                    this.dealPartName(otherObj, a); // 处理多语名称
                    otherObj.multilangTranslates = a.sideData.multilangTranslates; // 从侧拉数据中取出多语数据给到后台
                }
                tmp.apps.push({
                    ...commonObj,
                    ...otherObj,
                });
            });
            result.push(tmp);
        });
        return result;
    }

    // 传给后台的格式为partsname,partsname2,partsname3等
    dealPartName(resultObj, a) {
        function dealName(res, source) {
            if (typeof source === 'object') {
                for (let k in source) {
                    const newK = k.replace('name', 'partname');
                    res[newK] = source[k].value;
                }
            }
        }

        // 取sideData.name 之前的侧拉多语名字
        if (a.sideData.hasOwnProperty('name')) {
            dealName(resultObj, a.sideData.name);
        }

        // 开启了公共配置，取公共配置的多语名字
        if (a.iscommon_configuration) {
            const publicName = (a.sideData.publicData && a.sideData.publicData.name);
            dealName(resultObj, publicName);
        }
    }

    setAjaxFlag = (flag) => {
        this.ajaxFlag = flag;
    }
    getAjaxFlag = () => this.ajaxFlag

    //保存 isOtherWay：从他其他地方调用保存
    saveGroupItemAndCard = ({ isOtherWay, saveCallback, close } = {}) => {
        if (this.getAjaxFlag()) {return;}
        this.setAjaxFlag(true);
        const tmpData = this.genSaveData();
        const { workbenchid, linkageData } = this.props;
        let saveData = {
            isuser: this.props.relateidObj.code, //0职责 1用户 2集团
            data: tmpData,
            workbenchid,
            workbenchLinkConfigShowVOS: linkageData,
            workbench_configuration: this.props.workbenchConfig,
        };
        let queryUrl = this.props.location && this.props.location.search;
        if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
            this.props.relateidObj.code = "0"; //职责
            saveData.isuser = "0";
            let querySubString = queryUrl.substring(
                queryUrl.indexOf("pk_responsibility"),
            );
            let relateid = querySubString.substring(
                querySubString.indexOf("=") + 1,
            );
            saveData.relateid = relateid; //存relateid
        } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
            // 集团管理员应用管理跳转工作桌面设置 2019-08-16
            this.props.relateidObj.code = "2"; //职责
            saveData.isuser = "2";
        }
        if (this.props.relateidObj.type === "workbench") { // 工作台管理
            saveData.workbenchid = this.props.relateidObj.data;
        } else if (this.props.relateidObj.code === "0") {
            saveData.relateid = this.props.relateidObj.data;
        }
        window.onbeforeunload = null; //保存之前清除window方法
        let requestFunc = (isDeletePerson = false) => {
            Ajax({
                url: `/nccloud/platform/appregister/setapp.do`,
                info: {
                    name: this.props.json[
                        "DesktopSetting-000004"
                    ] /* 国际化处理： 工作桌面配置*/,
                    action: this.props.json[
                        "DesktopSetting-000005"
                    ], /* 国际化处理： 保存*/
                },
                loading: true, //发送保存请求时页面显示loading
                data: {
                    ...saveData,
                    isDeletePerson,
                },
                success: res => {
                    const { data, success } = res.data;
                    requestFunc = null;
                    if (success) {
                        PubSub.publish('SetAppComplete', {
                            isuser: saveData.isuser,
                            workbenchid: data.workbenchid,
                        });
                        saveCallback && saveCallback();
                        //桌面编辑态保存
                        if (!isOtherWay) {
                            const isUserSave = this.props.relateidObj.type === "userID";
                            this.props.setSaveComplete(true);
                            Notice({
                                status: "success",
                                msg: isUserSave ? (typeof data === "string" ? data : data.msg) : this.props.json['DesktopSetting-000090' /* 保存成功 */],
                            });
                            if (isUserSave) {
                                setTimeout(() => {
                                    this.props.updateHomePage(() => {
                                        this.props.toggleEditStatus(false);
                                        this.setAjaxFlag(false);
                                    });
                                    // 清空常用链接redux数据（用户编辑时保存清除，工作台管理节点设计不清除，不然页面常用链接数据直接变没了）
                                    // this.props.setExternalLinks(null);
                                }, 1000);
                            } else { // 设计器保存
                                !close && PubSub.publish("reloadDesignDesktopData"); // 不关闭需要重载数据，因为各种key都变了
                                setTimeout(() => {
                                    if (close) {
                                        this.closeWindow();
                                    } else {
                                        this.props.setSaveComplete(false); // 不关闭需要重置保存标识，不然新增加的常用链接将无法触发保存
                                    }
                                    this.setAjaxFlag(false);
                                }, 1000);
                            }
                        } else { //其他地方调用桌面保存
                            this.props.updateHomePage();
                            this.setAjaxFlag(false);
                        }
                    } else {
                        Notice({ status: "error", msg: typeof data === "string" ? data : data.msg });
                        this.setAjaxFlag(false);
                    }
                },
                error: () => {
                    this.setAjaxFlag(false);
                }
            });
        };
        if (saveData.isuser == 0) { // 工作台设计保存
            this.isExistPersonal([saveData.workbenchid], '/nccloud/platform/appregister/isexistpersionworkbench.do').then(isExist => {
                if (isExist) {
                    promptBox({
                        color: 'warning',
                        title: this.props.json["DesktopSetting-000085"], // 是否同时删除所有的用户级工作台
                        beSureBtnName: this.props.json["DesktopSetting-000086"], // 是
                        cancelBtnName: this.props.json["DesktopSetting-000087"], // 否
                        hasCloseBtn: true,
                        beSureBtnClick: () => { requestFunc(true); },
                        cancelBtnClick: () => { requestFunc(); },
                    });
                } else {
                    requestFunc();
                }
            });
        } else {
            requestFunc();
        }
    };

    isExistPersonal(params, url) {
        return new Promise(resolve => {
            Ajax({
                data: params,
                url,
                loading: true,
                success: ({ data }) => {
                    if (data.success) {
                        resolve(data.data);
                    }
                },
            });
        });
    }

    //根据返回数据更新桌面
    updateDesktopData = groupData => {
        let appGroupMap = {}; //聚合应用数据
        groupData.forEach(group => {
            group.apps.forEach(a => {
                //聚合应用
                if (checkApp(a).isCompactApp) {
                    appGroupMap[a.cardid] = a.children;
                    a.children = []; //清空聚合应用数据
                }
                //外部链接
                if (a.externallink && checkApp(a).isExternalLink) {
                    this.props.setExternalLinks(a.externallink);
                }
            });
        });
        this.props.setAppGroupData(appGroupMap); //设置聚合应用
        this.props.updateGroupList(groupData);
    }
    toBeDefault = () => {
        // window.onbeforeunload = null;
        const { relateidObj, workbenchid } = this.props;
        const requestParams = { workbenchid, // 工作台主键
        };
        if (relateidObj.type === "workbench") { // 工作台管理
            requestParams.workbenchid = relateidObj.data;
        }
        let requestFunc = (isDelete = false) => {
            Ajax({
                url: `/nccloud/platform/appregister/resetworkbench.do`,
                data: requestParams,
                info: {
                    name: this.props.json[
                        "DesktopSetting-000004"
                    ] /* 国际化处理： 工作桌面配置*/,
                    action: this.props.json[
                        "DesktopSetting-000006"
                    ], /* 国际化处理： 恢复默认*/
                },
                loading: true,
                success: res => {
                    const { success } = res.data;
                    requestFunc = null;
                    if (success) {
                        this.props.onClearAll(true);
                        // 强制获取新的数据
                        getWorkbenchData({}, true).then(data => {
                            this.props.setWorkbenchData(data);
                            this.cancleSave();
                        });
                    }
                },
            });
        };
        this.isExistPersonal({ workbenchid }, '/nccloud/platform/appregister/isexistroleworkbench.do').then(isExist => {
            if (isExist) {
                requestFunc();
            } else {
                promptBox({
                    color: 'warning',
                    title: this.props.json["DesktopSetting-000088"], // 原工作台已不存在，无法恢复默认，是否删除当前工作台？
                    beSureBtnName: this.props.json["DesktopSetting-000086"], // 是
                    cancelBtnName: this.props.json["DesktopSetting-000087"], // 否
                    hasCloseBtn: true,
                    beSureBtnClick: () => { requestFunc(true); },
                });
            }
        });
    };
    //恢复默认设置
    showDefaultConfirm = () => {
        ControlTip({
            status: "warning",
            title: this.props.json[
                "DesktopSetting-000006"
            ] /* 国际化处理： 恢复默认*/,
            msg: this.props.json[
                "DesktopSetting-000008"
            ] /* 国际化处理： 确定要恢复至默认职责桌面吗？*/,
            onOk: () => {
                this.toBeDefault();
            },
        });
    };
    //取消弹窗
    showCancelConfirm = () => {
        //黎明封装弹窗
        ControlTip({
            fieldid: 'desksetting_cancel',
            status: "warning",
            title: this.props.json[
                "DesktopSetting-000009"
            ] /* 国际化处理： 取消*/,
            msg: this.props.json[
                "DesktopSetting-000010"
            ] /* 国际化处理： 确定要取消吗？*/,
            onOk: () => {
                this.cancleSave();
            },
        });
    };

    // 后台去重
    ajaxDeduplicateCards = () => {
        const { appGroupMap, saveExternalLinkData } = this.props;
        let groups = _.cloneDeep(this.props.groups);
        console.log('saveExternalLinkData', this.props.saveExternalLinkData);
        groups.forEach(group => {
            group.apps.forEach(a => {
                //聚合应用需要的数据
                if (checkApp(a).isCompactApp) {
                    a.children = appGroupMap[a.cardid]; //聚合应用内容
                }
                //外链的数据
                if (checkApp(a).isExternalLink) {
                    if (saveExternalLinkData[a.cardid]) {
                        a.externallink = saveExternalLinkData[a.cardid];
                    }
                }
            });
        });
        Ajax({
            url: '/nccloud/platform/appregister/disworkbench.do',
            info: {
                name: this.props.json['DesktopSetting-000004'], /* 国际化处理：工作桌面配置 */
                action: this.props.json['DesktopSetting-000047'], /* 国际化处理：一键去重 */
            },
            data: groups,
            loading: true,
            success: res => {
                let { data, success } = res.data;
                if (success && data) {
                    this.updateDesktopData(data);
                }
            },
        });
    }

    // 一键去重
    deduplicateCards = () => {
        ControlTip({
            status: "warning",
            title: this.props.json[
                "DesktopSetting-000049"
            ] /* 国际化处理： 去重*/,
            msg: this.props.json[
                "DesktopSetting-000050"
            ] /* 国际化处理： 确定要将所有分组内重复的小应用、小部件删除吗？*/,
            onOk: () => {
                this.ajaxDeduplicateCards();
            },
        });
    }
    //一键清空
    clearAll = () => {
        ControlTip({
            fieldid: 'desksetting-empty',
            status: "warning",
            title: this.props.json[
                "DesktopSetting-000045"
            ] /* 国际化处理： 清空*/,
            msg: this.props.json[
                "DesktopSetting-000046"
            ] /* 国际化处理： 确定要清空当前桌面分组、小应用、小部件吗？*/,
            onOk: () => {
                this.props.onClearAll();
                this.props.updateGroupList([]);
                this.props.setAppGroupData({});
                this.props.onCheckDeduplication([]);
                this.props.setLinkageData([]);

                // 清空之后，默认再给加上一个分组，避免中间空分组状态（需要点击新增分组）
                setTimeout(() => { // 这个延迟必须要，不要问为什么，没有时间研究，不知道
                    this.props.addFirstGroupItem();
                });
            },
        });
    }

    // 联动设置
    linkageSet = () => {
        // console.log('联动设置');
        const { linkageData } = this.props;
        const commonWidgets = [...Object.entries(PUB_WIDGET_APPCODES).map(([key, code]) => code), '10182002'];
        const widgets = this.props.groups[0].apps.filter(item => item.apptype === '2' && !commonWidgets.includes(item.appcode)); // 小部件合集
        const newLinkageData = [];
        const effectiveLinkData = getEffectiveLinkData(linkageData, this.props.groups);
        widgets.forEach(widget => {
            const existed = effectiveLinkData.find(item => item.source_partid === widget.cardid);
            if (existed) {
                newLinkageData.push(existed);
            } else {
                newLinkageData.push({
                    source_partid: widget.cardid,
                    name: widget.name,
                    linkConfigVO: [],
                });
            }
        });
        // console.log(newLinkageData);
        this.setState({
            linkageSetModal: true,
            linkageModalData: newLinkageData,
            linkageActive: newLinkageData[0], // 默认选中第一个
        });
    }
    linkageChecked = (checked, item) => {
        const { linkageActive } = this.state;
        if (checked) {
            linkageActive.linkConfigVO.push({
                key: item.source_partid,
                value: item.name,
            });
        } else {
            _.remove(linkageActive.linkConfigVO, ite => ite.key === item.source_partid);
        }
        this.setState({ linkageActive });
    }
    linkageCheckedAll = (checked, linkOptions) => {
        const { linkageActive, linkageModalData } = this.state;
        _.remove(linkageActive.linkConfigVO);
        if (checked) {
            linkageActive.linkConfigVO.push(...linkOptions.map(item => {
                return {
                    key: item.source_partid,
                    value: item.name,
                };
            }));
        }
        this.setState({ linkageActive });
    }
    linkageSetModalClose = () => {
        this.setState({ linkageSetModal: false });
    }
    linkageSetModalConfirm = () => {
        const { linkageModalData } = this.state;
        const colors = [...linkageColors];
        const needColorData = []; // 需要设置颜色的数据
        linkageModalData.forEach(item => {
            if (item.color) {
                if (item.linkConfigVO && item.linkConfigVO.length) {
                    _.remove(colors, color => color === item.color); // 去除掉已经使用的颜色
                } else {
                    delete item.color; // 取消关联配置的删掉相应颜色
                }
            } else {
                if (item.linkConfigVO && item.linkConfigVO.length) {
                    needColorData.push(item);
                }
            }
        });
        needColorData.forEach(item => {
            if (!colors.length) { // 颜色用完之后，新一轮重复用
                colors.push(...linkageColors);
            }
            item.color = colors[0];
            colors.splice(0, 1);
        });
        this.linkageSetModalClose();
        this.props.setLinkageData(this.state.linkageModalData);
    }

    closeWindow = () => {
        window.top.opener = null;
        window.top.close();
    }

    // 关闭
    handleClose = () => {
        const noChange = _.isEqual(this.props.groups, this.props.initialGroups) && _.isEqual(this.props.appGroupMap, this.props.defaultAppGroupData);
        if (noChange) {
            this.closeWindow();
        } else {
            promptBox({
                color: 'warning',
                title: langCheck('0000PUB-000007'), // 保存
                content: langCheck('0000PUB-000508'), // 您即将离开当前工作台，是否要保存？
                beSureBtnName: langCheck('0000PUB-000568'), // 保存并关闭
                cancelBtnName: langCheck('0000PUB-000027'), // 关闭
                hasCloseBtn: true,
                beSureBtnClick: () => {
                    this.saveGroupItemAndCard({ close: true });
                },
                cancelBtnClick: this.closeWindow,
            });
        }
    }

    handleCancel = () => {
        if (this.getAjaxFlag()) {return;}
        const noChange = _.isEqual(this.props.groups, this.props.initialGroups) && _.isEqual(this.props.appGroupMap, this.props.defaultAppGroupData);
        if (noChange) {
            this.cancleSave();
        } else {
            this.showCancelConfirm();
        }
    }

    // 预览
    handlePreview = () => {
        const workbenchId = this.props.relateidObj.data;
        const previewUrl = getOriginPath() + "resources/workbench/public/common/main/index.html#/?previewMode=true&workbenchid=" + workbenchId;
        window.parent.open(previewUrl, workbenchId);
    }

    // 处理快捷键
    handleHotKey = key => {
        const hasModal = document.querySelector('.base-modal');
        if (hasModal) { return; }

        const { isDesign } = this.state;
        if (key === NCHotKeys.USUAL_KEYS.SAVE) {
            this.saveGroupItemAndCard();
        }
        if (key === NCHotKeys.USUAL_KEYS.CAEL) {
            isDesign ? this.handleClose() : this.handleCancel();
        }
    }

    globalConfig = () => {
        PubSub.publish("workbenchGlobalConfig"); // 工作台全局配置
    }

    render() {
        const { groups, editable, relateidObj, isRespWorkbench } = this.props;
        const { isDesign } = this.state;
        if (!editable) {return null;}
        // console.log(json);
        const groupNameRadioGroup = this.getGroupItemNameRadio(groups);
        //用户工作桌面配置才显示‘恢复默认’按钮
        const toBeDefaultStyle = { display: relateidObj.type === "userID" ? "" : "none" };
        const { linkageModalData, linkageActive } = this.state;
        const linkOptions = linkageModalData.filter(item => item.source_partid !== linkageActive.source_partid);
        return (
            <NCDiv
                className={`nc-workbench-home-footer ${isDesign ? 'designer-footer' : ''}`}
                fieldid="bottom-area"
                areaCode={NCDiv.config.BOTTOM}
            >
                <NCHotKeys
                    keyMap={{
                        saveHandler: NCHotKeys.USUAL_KEYS.SAVE,
                        cancelHandler: NCHotKeys.USUAL_KEYS.CAEL,
                    }}
                    handlers={{
                        saveHandler: () => { this.handleHotKey(NCHotKeys.USUAL_KEYS.SAVE); },
                        cancelHandler: () => { this.handleHotKey(NCHotKeys.USUAL_KEYS.CAEL); },
                    }}
                    focused={true}
                />
                {/* <div className="footer-left button-app-wrapper group-btns">
                    {this.getMoveCardButton(
                        this.props.json["DesktopSetting-000013"], // 国际化处理： 移动
                        "move",
                        this.showModalVisible
                    )}
                    {this.getMoveCardButton(
                        this.props.json["DesktopSetting-000012"],
                        "delete",
                        () => {
                            this.deleteTargetCards("isChecked", true);
                        }
                    )}
                </div> */}

                {
                    isDesign && <div className="footer-left button-app-wrapper group-btns">
                        {/* <NCButton onClick={this.globalConfig} className="footer-button">
                            全局配置
                        </NCButton> */}
                        {/* 联动设置（工作台管理过来的才有） */}
                        <NCButton onClick={this.linkageSet} className="footer-button">
                            {this.props.json["DesktopSetting-000081"]}
                        </NCButton>
                    </div>
                }

                <div className="footer-left button-app-wrapper group-btns">
                    <NCButton
                        fieldid="reset"
                        style={toBeDefaultStyle}
                        onClick={this.showDefaultConfirm}
                        className="footer-button"
                        disabled={isRespWorkbench}
                    >
                        {this.props.json["DesktopSetting-000006"]}
                        {/* /* 国际化处理： 恢复默认*/}
                    </NCButton>
                    {/* [NCC-45253]大佬们要求把这个新作的功能去掉 */}
                    {/* 国际化处理： 一键去重 */}
                    {/* <NCButton
                        fieldid="deduplicate"
                        disabled={groups.length === 0}
                        onClick={this.deduplicateCards}
                        className="footer-button"
                    >
                        {this.props.json["DesktopSetting-000047"]}
                    </NCButton> */}
                    <NCButton
                        fieldid="clearAll"
                        disabled={groups.length === 0}
                        onClick={this.clearAll}
                        className="footer-button"
                    >
                        {this.props.json["DesktopSetting-000044"]}
                        {/* /* 国际化处理： 一键清空*/}
                    </NCButton>
                    {this.getExpiredCardButton(
                        this.props.json["DesktopSetting-000011"],
                        () => {
                            /* 国际化处理： 清除失效*/
                            this.deleteTargetCards("haspower", false);
                        },
                    )}
                </div>
                <div className="footer-right button-app-wrapper">
                    <NCTooltip
                        overlay={`${this.props.json["DesktopSetting-000005"]}(${NCHotKeys.USUAL_KEYS.SAVE})`}
                    >
                        <NCButton
                            fieldid="save"
                            colors="primary"
                            onClick={() => this.saveGroupItemAndCard()}
                            className='footer-button'

                        >
                            {this.props.json["DesktopSetting-000005"]}
                            {/* /* 国际化处理： 保存*/}
                        </NCButton>
                    </NCTooltip>
                    {
                        isDesign && <NCTooltip
                            overlay={this.props.json["DesktopSetting-000096"]}
                        >
                            <NCButton
                                onClick={this.handlePreview}
                                className='footer-button'
                            >
                                {langCheck('0000PUB-000557' /* 预览 */)}
                            </NCButton>
                        </NCTooltip>
                    }
                    <NCTooltip
                        overlay={`${isDesign ? langCheck('0000PUB-000027' /* 关闭 */) : this.props.json["DesktopSetting-000009" /* 取消 */] }(${NCHotKeys.USUAL_KEYS.CAEL})`}
                    >
                        {
                            isDesign ? <NCButton
                                onClick={this.handleClose}
                                className='footer-button'
                            >
                                {langCheck('0000PUB-000027' /* 关闭 */)}
                            </NCButton>
                                :
                                <NCButton
                                    onClick={this.handleCancel}
                                    fieldid="cancel"
                                    className='footer-button'
                                >
                                    {this.props.json["DesktopSetting-000009" /* 取消 */]}
                                </NCButton>
                        }
                    </NCTooltip>
                </div>
                <HotKeysModal
                    closable={false}
                    title={
                        this.props.json["DesktopSetting-000014"]
                    } /* 国际化处理： 移动到*/
                    mask={false}
                    wrapClassName="desk-setting-vertical-center-modal"
                    visible={this.state.modalVisible}
                    onOk={this.onOkMoveDialog}
                    onCancel={this.showModalHidden}
                >
                    {groupNameRadioGroup}
                </HotKeysModal>

                {/* 联动设置弹窗 */}
                <NCModal className="linkage-set-modal" show={this.state.linkageSetModal} onHide={this.linkageSetModalClose}>
                    <NCModal.Header closeButton>
                        <NCModal.Title>{this.props.json["DesktopSetting-000081" /* 联动设置 */]}</NCModal.Title>
                    </NCModal.Header>

                    <NCModal.Body className="linkage-modal-body">
                        <div className="modal-left">
                            <div className="top-container">{this.props.json['DesktopSetting-000082' /* 小部件名称 */]}：</div>
                            <div className="content-container">
                                {
                                    linkageModalData.map(item => <div
                                        className={`content-item ${linkageActive.source_partid === item.source_partid ? 'active' : ''}`}
                                        onClick={() => {
                                            if (item.source_partid === linkageActive.source_partid) {return;}
                                            this.setState({ linkageActive: item });
                                        }}
                                    >
                                        <span>{item.name}</span>
                                        {item.linkConfigVO.length ? <span className="configured">{this.props.json['DesktopSetting-000083' /* 已配置 */]}</span> : null}
                                    </div>)
                                }
                            </div>
                        </div>
                        <div className="modal-right">
                            <div className="top-container">
                                <NCCheckbox
                                    disabled={!linkOptions.length}
                                    indeterminate={Boolean(linkageActive && linkageActive.linkConfigVO.length)}
                                    checked={Boolean(linkageActive && linkageActive.linkConfigVO.length === linkOptions.length)}
                                    onChange={value => { this.linkageCheckedAll(value, linkOptions); }}
                                >{this.props.json['DesktopSetting-000084' /* 全选 */]}</NCCheckbox>
                            </div>
                            <div className="content-container">
                                {
                                    linkOptions.map(item => <div className="content-item">
                                        <NCCheckbox
                                            checked={linkageActive && linkageActive.linkConfigVO.some(ite => ite.key === item.source_partid)}
                                            onChange={value => { this.linkageChecked(value, item); }}
                                        >{item.name}</NCCheckbox>
                                    </div>)
                                }
                            </div>
                        </div>
                    </NCModal.Body>

                    <NCModal.Footer>
                        <NCButton onClick={this.linkageSetModalConfirm} colors="primary">{this.props.json['DesktopSetting-000015' /* 确定 */]}</NCButton>
                        <NCButton onClick={this.linkageSetModalClose} colors="secondary">{this.props.json['DesktopSetting-000009' /* 取消 */]}</NCButton>
                    </NCModal.Footer>
                </NCModal>
            </NCDiv>
        );
    }
}
export default connect(
    state => ({
        groups: state.gridLayoutData.groups,
        initialGroups: state.gridLayoutData.initialGroups,
        json: state.gridLayoutData.json,
        editable: state.gridLayoutData.editable,
        updateHomePage: state.gridLayoutData.updateHomePage,
        appGroupMap: state.gridLayoutData.appGroupMap,
        defaultAppGroupData: state.gridLayoutData.defaultAppGroupData,
        saveExternalLinkData: state.gridLayoutData.saveExternalLinkData,
        workbenchid: state.appData.workbenchId,
        linkageData: state.appData.linkageData,
        isRespWorkbench: state.gridLayoutData.isRespWorkbench,
        workbenchConfig: state.gridLayoutData.workbenchConfig,
    }),
    {
        updateGroupList,
        toggleEditStatus,
        setAppGroupData,
        setSaveComplete,
        setUpdateLayout,
        setExternalLinks,
        setLinkageData,
        setWorkbenchData,
    },
)(withRouter(MyFooter));
